import getData from "@/__main__/get-data.mjs";
import { API_V2_ROUTING } from "@/feature-lol-rust-be/constants.mjs";
import ProfileRanksModel from "@/feature-lol-rust-be/profile-ranks-model.mjs";
import { getDerivedId } from "@/game-lol/utils/util.mjs";

export default function ({
  region,
  gameName,
  tagLine,
  path,
  options = {},
}: {
  region: string;
  gameName: string;
  tagLine: string;
  path?: string[];
  options: object;
}) {
  const p = region.toUpperCase();
  const baseURL = API_V2_ROUTING[p] || API_V2_ROUTING["NA1"];
  return getData(
    `${baseURL}/riot_account_v2/lol/${p.toUpperCase()}/${gameName}/${tagLine}`,
    ProfileRanksModel,
    path || ["lol", "profileRanks", getDerivedId(p, null, gameName, tagLine)],
    {
      ...options,
    },
  );
}
